import { useEffect, MutableRefObject } from 'react'
import maplibregl from 'maplibre-gl'
import { createMapStyle } from '../create-map-style'
import { useMapFooter } from '../ui/map-footer'
import { createBuildingLayer } from '../layers/building-layer'

interface UseMapInitializationProps {
  mapContainer: MutableRefObject<HTMLDivElement | null>
  mapRef: MutableRefObject<maplibregl.Map | null>
  onFloorClick?: (layerId: number) => void
  onMapReady?: () => void
}

export const useMapInitialization = ({
  mapContainer,
  mapRef,
  onFloorClick,
  onMapReady,
}: UseMapInitializationProps) => {
  useMapFooter(mapContainer)

  useEffect(() => {
    if (!mapContainer.current) return

    const map = new maplibregl.Map({
      container: mapContainer.current,
      style: createMapStyle() as any,
      center: [30.323477, 59.889941],
      zoom: 17,
      pitch: 60,
      bearing: 30,
    })

    mapRef.current = map
    onMapReady?.()

    map.addControl(
      new maplibregl.NavigationControl({ visualizePitch: true }),
      'top-right',
    )

    map.on('load', () => {
      const buildingLayer = createBuildingLayer({
        onFloorClick,
        scale: 1.1,
        rotation: 0,
      })
      map.addLayer(buildingLayer as any)
    })

    // Вывод в консоль по клику: layer id, feature id и properties (для фильтрации зданий и т.д.)
    map.on('click', e => {
      const features = map.queryRenderedFeatures(e.point)
      if (features.length === 0) return
      console.log('--- MapLibre click: объекты под курсором ---')
      features.forEach((f, i) => {
        console.log(`[${i}] layer: "${f.layer.id}"`, {
          source: f.source,
          sourceLayer: f.sourceLayer,
          id: f.id,
          properties: f.properties,
        })
      })
      console.log('-------------------------------------------')
    })

    return () => {
      map.remove()
    }
  }, [mapContainer, mapRef, onFloorClick])
}
